import './utils/polyfills.js';
import React from "react";
import ReactDOM from "react-dom";
import { CookiesProvider } from "react-cookie";
import "./scss/index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./utils/OptIn/OptIn";

window.optInOptions = {
  cookieConfig: {
    name: "optIn",
    expires: "365d",
    path: "/",
    domain: "",
    secure: false,
    sameSite: "Lax"
  },
  heading: "Datenschutzhinweis",
  text: {
    front: 'Um die Online-Anwendung nutzen zu können, kommen Cookies zum Einsatz. Wenn Sie das Online-Angebot nutzen, erklären Sie sich hiermit einverstanden. Weitere Informationen zu Cookies finden Sie in unseren <a href="/datenschutz" target="_blank">Daten&shy;schutz&shy;hinweisen</a>.',
    config: 'Um die Online-Anwendung nutzen zu können, kommen Cookies zum Einsatz. Wenn Sie das Online-Angebot nutzen, erklären Sie sich hiermit einverstanden. Weitere Informationen zu Cookies finden Sie in unseren <a href="/datenschutz" target="_blank">Daten&shy;schutz&shy;hinweisen</a>.'
  },
  labels: {
    acceptAll: "Cookies akzeptieren",
    showConfig: "Konfigurieren",
    saveConfig: "Auswahl speichern"
  },
  choices: {
    necessary: {
      label: "Technisch notwendige Cookies",
      description: "Diese Cookies sind technisch erforderlich, damit diese Website richtig funktioniert. Sie dienen unter anderem für die Funktion der portalweiten Suche sowie für das Merken Ihrer persönlichen Einstellungen, z.B. Ihre hier getroffenen Datenschutzeinstellungen.",
      selected: true,
      unchangeable: true
    }
  },
  bodyScrollStop: ["overflow-y: hidden"]
};

window.onload = function () {
  if (window.location.href.indexOf("datenschutz") === -1) new window.__MRM_OPTIN(window.optInOptions, true);
};

const CookieApp = () => {
  return (
    <CookiesProvider>
      <App />
    </CookiesProvider>
  );
};

ReactDOM.render(<CookieApp />, document.getElementById("admin"));
if (module.hot) module.hot.accept();
serviceWorker.unregister();
